import { apiFetch } from './client';

export interface Agent {
  id: string;
  email: string;
  name: string;
  role: string;
  active: boolean;
  createdAt: string;
  updatedAt?: string;
  departmentId: string | null;
  department: { id: string; name: string } | null;
  branches: { id: string; name: string }[];
  assignedCustomerCount?: number;
}

export function listAgents(): Promise<{ agents: Agent[] }> {
  return apiFetch<{ agents: Agent[] }>('/agents');
}

export function createAgent(data: {
  email: string;
  name: string;
  role: string;
  password: string;
}): Promise<{ agent: Agent }> {
  return apiFetch<{ agent: Agent }>('/agents', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function setAgentActive(id: string, active: boolean): Promise<{ agent: Agent }> {
  return apiFetch<{ agent: Agent }>(`/agents/${id}/active`, {
    method: 'PUT',
    body: JSON.stringify({ active }),
  });
}

export function setAgentRole(
  id: string,
  role: 'agent' | 'admin' | 'supervisor',
): Promise<{ agent: Agent }> {
  return apiFetch<{ agent: Agent }>(`/agents/${id}/role`, {
    method: 'PUT',
    body: JSON.stringify({ role }),
  });
}

export function resetAgentPassword(id: string, password: string): Promise<{ ok: boolean }> {
  return apiFetch<{ ok: boolean }>(`/agents/${id}/reset-password`, {
    method: 'POST',
    body: JSON.stringify({ password }),
  });
}

export interface AgentDeletionMoved {
  customers: number;
  claims: number;
  notes: number;
  cannedReplies: number;
  personalTags: number;
}

/** Permanently deletes an agent after handing everything they own to `transferTo`. */
export function deleteAgent(id: string, transferTo: string): Promise<{ ok: boolean; moved: AgentDeletionMoved }> {
  return apiFetch<{ ok: boolean; moved: AgentDeletionMoved }>(`/agents/${id}/delete`, {
    method: 'POST',
    body: JSON.stringify({ transferTo }),
  });
}

export function setAgentBranches(
  id: string,
  branchIds: string[],
): Promise<{ ok: boolean; branchIds: string[] }> {
  return apiFetch<{ ok: boolean; branchIds: string[] }>(`/agents/${id}/branches`, {
    method: 'PUT',
    body: JSON.stringify({ branchIds }),
  });
}
